import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import { useForm } from "react-hook-form";
import CommonForm from "Components/Common/CommonForm";
import { remarksSubmissionFields } from "../../../modules/Volunteer/AssigningStudyModule/StudyICF/helper/studyicf.constant";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: (remarks: string) => void;
  isloading: boolean;
}

interface FormValues {
  remarks: string;
}

const StudyICFRemarksModal: React.FC<Props> = ({
  isOpen,
  toggle,
  onConfirm,
  isloading,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      remarks: "",
    },
    mode: "onChange",
  });

  const remarksValue = watch("remarks", "") || "";

  useEffect(() => {
    if (isOpen) {
      reset({ remarks: "" });
    }
  }, [isOpen, reset]);

  const onSubmit = (data: FormValues) => {
    onConfirm(data.remarks.trim());
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        if (!isloading) {
          toggle();
        }
      }}
      centered
      backdrop="static"
      className="common_modal"
    >
      <ModalHeader
        toggle={() => {
          if (!isloading) {
            toggle();
          }
        }}
        className="p-3 border-bottom"
      >
        Submission Remarks
      </ModalHeader>

      <ModalBody className="p-3 pb-4">
        <CommonForm
          fields={remarksSubmissionFields}
          control={control}
          errors={errors}
          columns={1}
        />
        <div className="d-flex justify-content-end align-items-center mt-1">
          <div
            className={`fs-11 fw-medium ${
              remarksValue.length > 480 ? "text-danger" : "text-muted"
            }`}
            style={{ minWidth: "60px", textAlign: "right" }}
          >
            {remarksValue.length} / 500
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="p-3 border-top">
        <Button
          outline
          color="light"
          onClick={toggle}
          disabled={isloading}
          className="px-4"
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit(onSubmit)}
          disabled={isloading}
          className="px-4"
        >
          {isloading && <Spinner size="sm" className="me-2" />}
          Submit Final
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StudyICFRemarksModal;
